module.exports = __webpack_public_path__ + "static/media/MaiQuyTrung_CV.62d2380f.pdf";